import { css } from 'aphrodite';
import { FC } from 'react';
import { styleSheet } from './styles';

interface GroupedEmailTableProps {
	variant?: 'email' | 'automations';
	showCheckboxes?: boolean;
}

export const EmailReportTableHeader: FC<GroupedEmailTableProps> = ({ variant = 'email', showCheckboxes = false }) => {
	return (
		<header className={css(styleSheet.header)}>
			{showCheckboxes && <div className={css(styleSheet.checkboxPlaceholder)} />}
			<h2 className={css(styleSheet.headerTitleSubject)}>Email Subject Line</h2>
			<h2 className={css(styleSheet.headerTitleTags)}>Sent To (Tags or Individuals)</h2>
			{variant === 'email' ? (
				<h2 className={css(styleSheet.headerTitle)}>Stats</h2>
			) : (
				<div className={css(styleSheet.headerTitle)} />
			)}
			{variant === 'email' ? <div className={css(styleSheet.headerPlaceholder)} /> : null}
		</header>
	);
};
